import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, ComprovanteInscricao } from './types';

export const INITIAL_STATE: ComprovanteInscricao = {
	status: 0,
	data: null,
	dataRequest: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): ComprovanteInscricao {
	return produce(state, draft => {
		switch (action.type) {
			case Types.COMPROVANTE_INSCRICAO_REQUEST: {
				draft.dataRequest = action.payload;
				break;
			}
			case Types.COMPROVANTE_INSCRICAO_SUCCESS: {
				draft.status = action.payload.response.status;
				draft.data = action.payload.response.data;
				break;
			}
			case Types.COMPROVANTE_INSCRICAO_FAILURE: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}
			default:
		}
		return draft;
	});
}
